// responsiveTypography.ts
import { Theme } from "@mui/material"

export const responsiveTypography = (theme: Theme): Theme => {
    // eslint-disable-next-line no-param-reassign
    theme.typography.h2 = {
        fontSize: "4rem",
        fontWeight: 400,
        lineHeight: "1.2",
        [theme.breakpoints.down("sm")]: {
            fontSize: "2.25rem",
            fontWeight: 400,
            lineHeight: "1.2",
        },
    }
    // eslint-disable-next-line no-param-reassign
    theme.typography.h3 = {
        fontSize: "2.7rem",
        fontWeight: 500,
        lineHeight: "1.2",
        [theme.breakpoints.down("sm")]: {
            fontSize: "2rem",
            fontWeight: 500,
            lineHeight: "1.2",
        },
    }
    // Add other responsive typography here...

    return theme
}
